import { Translations } from './translations';

const en: Translations = {
  common: {
    about: 'About',
    solutions: 'Solutions',
    otherServices: 'Services',
    contact: 'Contact',
    language: 'Language',
    learnMore: 'Learn More',
    address: 'Where to find us',
    letsChat: "Let's Chat",
  },
  home: {
    intro: {
      title: 'Stranded without battery on the road?',
      text: 'Avoid surprises, our system warns before failure. More safety, fewer stops and more savings!',
      button: [{ title: 'Learn More' }],
    },
    middleBlock: {
      title: 'Made for any road, any vehicle',
      text: 'Our system monitors your batteries in real time and warns before failure, avoiding stops and losses.',
      button: 'Contact Us',
    },
    about: {
      title: 'Smart and Adaptive',
      text: 'Real-time battery monitoring with sensors and A.I., like a miniature lab inside your vehicle!',
      section: [
        { title: 'Small investment, big return!', content: 'Quick and easy installation in any vehicle.', icon: '' },
        { title: 'Very Low Consumption!', content: 'Works with little energy and does not affect vehicle performance.', icon: '' },
      ],
    },
    contact: {
      title: 'Get in Touch',
      text: 'Talk to Vizage and learn about our solutions!',
    },
    devices: {
      title: 'Our Devices',
      content: 'Discover our complete line of battery monitors.',
    },
    otherServices: {
      title: 'Explore Other Services',
      subtitle: 'Complementary solutions for monitoring, failure prevention, and critical system management.',
      items: [
        {
          title: 'Generator Monitoring',
          subtitle: 'Monitor generator batteries and critical conditions to reduce failures and unexpected downtime.',
          icon: 'svg/generator.svg',
        },
        {
          title: 'UPS Monitoring',
          subtitle: 'Monitor UPS batteries and identify signs of failure before they impact your operation.',
          icon: 'svg/nobreak.svg',
        },
        {
          title: 'Vizage External Monitoring',
          subtitle: 'Our team monitors your equipment, analyzes alerts, and helps identify issues before they become failures.',
          icon: 'svg/monitoring.svg',
        },
      ],
    },
    supports: 'Supports',
  },
  footer: {
    tellUsEverything: 'Tell us about your needs',
    doYouHaveQuestion: 'Ready to prevent battery failures? Let\'s discuss your monitoring needs.',
  },
  links: {
    title: 'Monitoring that anticipates the future.',
    bio: 'Smart solutions to monitor your batteries health in real time.',
    items: {
      company: { label: 'Discover Vizage', description: 'Technology for intelligent battery monitoring' },
      whatsapp: { label: 'Talk to our team', description: 'Get in touch with us on WhatsApp' },
      email: { label: 'Send us an email', description: 'Contact the Vizage team directly' },
      linkedin: { label: 'Follow Vizage on LinkedIn', description: 'News, projects, and behind the scenes' },
      instagram: { label: 'Follow us on Instagram', description: 'Vizage content and updates' },
    },
    socialLabels: {
      whatsapp: 'Vizage on WhatsApp',
      email: 'Send an email to Vizage',
      linkedin: 'Vizage on LinkedIn',
      instagram: 'Vizage on Instagram',
    },
    footer: 'VIZAGE TECNOLOGIA LTDA',
  },
  devices: {
    vizageNode: 'Vizage Node',
    vizageMesh: 'Vizage Mesh',
    oneTimePayment: 'One-time payment',
    localAlert: 'Local alert',
    bluetoothConnection: 'Bluetooth connection',
    singleVehicle: 'Can only be used in 1 vehicle',
    findNearbyShops: 'Find nearby auto shops',
    cloudAlert: 'Cloud alert',
    wirelessCommunication: 'Wireless communication',
    onlineManagement: 'Online management platform',
    unlimitedVehicles: 'Unlimited vehicles',
    personalizedSupport: 'Personalized support',
  },
};

export default en;
